import { resolveAddinOperatingOrgCode } from '../organisations/resolve-addin-operating-org-code.util';

/** Selected organisation context for AMS, same header as the Trace web activity handler. */
export const ORGANIZATION_CODE_HEADER = 'x-organization-code';

export interface ActivityRequestHeaderOptions {
    /**
     * When false, omit `x-organization-code`.
     * Get-ManagedOrganisations must see every organisation the user can access.
     */
    includeOrganisationCode?: boolean;
}

/** JSON + bearer headers, plus the operating organisation when one is known. */
export function buildActivityRequestHeaders(
    accessToken: string,
    options?: ActivityRequestHeaderOptions
): Record<string, string> {
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
    };
    if (options?.includeOrganisationCode === false) {
        return headers;
    }
    const organisationCode = resolveAddinOperatingOrgCode();
    if (organisationCode) {
        headers[ORGANIZATION_CODE_HEADER] = organisationCode;
    }
    return headers;
}
